<template lang="pug">
    //- 写真詳細
    transition(name="detail")
        #photo-detail(v-if="detail")
            //- スマホのみヘッダー
            .spheader
                a.logo(href="#"): img(src="../assets/img/main-logo.svg")
                a.back(@click="detailFalse") &lt;
            .box
                //- 閉じるボタン
                img.close(src="../assets/img/40.svg",@click="detailFalse")
                //- メイン部分
                .content
                    photo-contents.photo
                    //- テキスト
                    p(v-html="comment")
                    //- メールボタン（スマホのみ）
                    a.mail(href="contact"): img(src="@/assets/img/33m.svg")

                //- リンクボタン（pc）
                .link
                    //- インスタAPIからURL引っ張ってきてここから飛べるようにする
                    a.insta(:href="$store.getters.getDetail.permalink",target="_blank")
                        img(src="@/assets/img/41.png")
                        span please look!
                    a.mail(href="contact"): img(src="@/assets/img/33m.svg")

</template>
<style lang="scss" scoped>
#photo-detail {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #fff;
    transition: 0.3s;
    z-index: 100;

    @media #{$pc} {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba($color: #000000, $alpha: 0.8);
    }

    > .spheader {
        height: 8%;
        @include touch-only;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        > .back {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 16px;
            font-size: 24px;
            color: #30526e;
            text-decoration: none;
            cursor: pointer;
        }

        > .logo > img {
            width: 110px;
        }
    }
}

#photo-detail > .box {
    background: #fff;
    position: relative;
    width: 100%;
    height: 100%;

    @media #{$pc} {
        width: 720px;
        height: 540px;
        padding: 32px 16px;
    }

    > .close {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
        @include pc-only;
    }

    // インスタから引っ張ってきたデータを表示する部分
    > .content {
        width: 100%;
        height: 70%;
        margin: 0 auto;
        padding: 32px 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #e6e7ec;
        position: relative;

        @media #{$pc} {
            background: transparent;
            justify-content: center;
            width: 400px;
            height: 100%;
            padding: 0;
        }

        > .photo {
            margin-bottom: 16px;
        }

        > p {
            font-size: 12px;
            color: #30526e;
            width: 314px;

            overflow-y: scroll;

            @media screen and (max-width: 360px) {
                width: 280px;
            }

            @media #{$pc} {
                width: 391px;
            }
            // TODO: あとで明朝体指定
        }

        > .mail {
            @include touch-only;
            width: 25px;
            position: absolute;
            bottom: 16px;
            right: 24px;
        }
    }

    > .link {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 22%;

        @media #{$pc} {
            position: absolute;
            bottom: 20px;
            right: 20px;
            height: auto;
        }

        > .insta {
            width: 76px;
            text-decoration: none;
            display: flex;
            flex-direction: column;
            align-items: center;

            @media #{$pc} {
                margin-bottom: 12px;
                width: 49px;
            }
        }

        > .insta > span {
            @include touch-only;
            font-size: 12px;
            padding: 8px 0;
            color: #30526e;
        }
        > .mail {
            display: block;

            @include pc-only;

            @media #{$pc} {
                width: 20px;
            }
        }

        > .insta > img,
        > .mail > img {
            width: 100%;
        }
    }
}

// アニメーション
.detail-enter,
.detail-leave-to {
    transform: translateX(100%);
    @media #{$pc} {
        opacity: 0;
        transform: translateX(0%);
    }
}

.detail-enter-to,
.detail-leave {
    opacity: 1;
    transform: translateX(0%);
}
</style>
<script>
import photoContents from "@/components/PhotoContents";

export default {
    components: {
        photoContents
    },
    props: {},
    computed: {
        detail() {
            return this.$store.getters.getIsDetail;
        },
        comment() {
            if (this.$store.getters.getDetail.caption) {
                var str = this.$store.getters.getDetail.caption;
                var tags = str.match(/(#).*?(#|\s|\n|$)/g);
                var tag = tags[0].replace(/(#|\s|\n|$)/g, "");
                var text = str.replace(
                    /(#).*?(?=#|\s|\n|$)/,
                    '<a class="link" href="https://www.instagram.com/explore/tags/' +
                        tag +
                        '" target="_blank" style="color:#30526e">#' +
                        tag +
                        "</a>"
                );
                text = text.replace(/\r?\n/g, "<br>");
                return text;
            } else {
                return "";
            }
        }
    },
    methods: {
        detailFalse() {
            this.$store.dispatch("setDetailFalse");
            //// console.log("false");
        }
    }
};
</script>
